import React from 'react'
import { useDropzone } from 'react-dropzone'
import './styles.scss'
import { Label } from 'reactstrap'

export function FileUpload({
  text,
  suggestion,
  onDrop,
  maxSize = 500000,
  accept = ['image/jpeg', 'image/png'],
  className = ''
}) {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxSize,
    multiple: false,
    accept
  })

  return (
    <div
      {...getRootProps({
        className: `customDropzone ${className}`.trim()
      })}
    >
      <input {...getInputProps()} />
      <Label dangerouslySetInnerHTML={{ __html: text }} />
      {suggestion ? (
        <em dangerouslySetInnerHTML={{ __html: suggestion }} />
      ) : null}
    </div>
  )
}
